<template>
  <van-pull-refresh
    v-model="isRefreshLoading"
    class="refresh-list"
    @refresh="$emit('refresh')">
    <van-list
      v-model="isListLoading"
      :finished="finished"
      finished-text="没有更多了"
      :error.sync="isError"
      error-text="请求失败，点击我重新加载"
      @load="$emit('load')">
      <slot />
    </van-list>
  </van-pull-refresh>
</template>

<script>
export default {
  name: 'RefreshList',
  props: {
    refreshLoading: {
      type: Boolean,
      required: true
    },
    listLoading: {
      type: Boolean,
      required: true
    },
    finished: {
      type: Boolean,
      required: true
    },
    error: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isRefreshLoading: {
      get () {
        return this.refreshLoading
      },
      set (value) {
        this.$emit('update:refreshLoading', value)
      }
    },
    isListLoading: {
      get () {
        return this.listLoading
      },
      set (value) {
        this.$emit('update:listLoading', value)
      }
    },
    isError: {
      get () {
        return this.error
      },
      set (value) {
        this.$emit('update:error', value)
      }
    }
  }
}
</script>

<style scoped>
.refresh-list {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/refreshList.vue